import store from '../../store'
import { login, getInfo, getService, joinService } from '@/api/login'
import { getBranchById } from '@/api/branch'
import { signupIMSTijarah } from '@/api/signup'
import { getCompanies } from '@/api/company'
import { getRelations } from '@/api/relation'
import { getUnreadNotifications } from '@/api/serviceNotifications'
import { getRequestedWHPartNotifications as imsteknobumiGetRequestedWHPartNotifications } from '@/api/imsteknobumiRequestedWHParts'
import { getPurchaseOrderNotifications as imsteknobumiGetPurchaseOrderNotifications } from '@/api/imsteknobumiPurchaseOrders'
import { getRequestedWHPartNotifications as sippGetRequestedWHPartNotifications } from '@/api/imsteknobumiRequestedWHParts'
import { getPurchaseOrderNotifications as sippGetPurchaseOrderNotifications } from '@/api/imsteknobumiPurchaseOrders'
import axios from 'axios'

// import { getToken, setToken, removeToken } from '@/utils/auth'

const defaultFeatures = {
  imstijarah: false,
  imsteknobumi: false,
  sipp: false,
  warisan: false,
  sipro: false,
  syntomax: false,
  ainmedicare: false,
  nims: false
}
const listOfFeatures = [
  {
    key: "imstijarah"
  },
  {
    key: "imsteknobumi"
  },
  {
    key: "sipp"
  },
  {
    key: "warisan"
  },
  {
    key: "sipro"
  },
  {
    key: "syntomax"
  },
  {
    key: "ainmedicare"
  },
  {
    key: "nims"
  }
]

const user = {
  state: {
    id: '',
    token: '',
    username: '',
    name: '',
    email: '',
    description: {},
    avatar: '',
    confirmed: false,
    role: '',
    awakRole: '',
    userData: {},
    branchData: {},
    branchLogo: null,
    features: {
      imstijarah: false,
      imsteknobumi: false,
      sipp: false,
      warisan: false,
      sipro: false,
      syntomax: false,
      ainmedicare: false,
      nims: false
    },
    currentSIPPModule: '',
    unreadNotifications: 0,
    requestedwhpartNotifications: 0,
    purchaseorderNotifications: 0,
    companies: []
  },
  getters: {
    id: state => state.id,
    token: state => state.token,
    avatar: state => state.avatar,
    username: state => state.username,
    name: state => state.name,
    email: state => state.email,
    description: state => state.description,
    confirmed: state => state.confirmed,
    role: state => state.role,
    awakRole: state => state.awakRole,
    userData: state => state.userData,
    profilePicture: state => state.profilePicture,
    branchData: state => state.branchData,
    branchLogo: state => state.branchLogo,
    features: state => state.features,
    currentSIPPModule: state => state.currentSIPPModule,
    unreadNotifications: state => state.unreadNotifications,
    requestedwhpartNotifications: state => state.requestedwhpartNotifications,
    purchaseorderNotifications: state => state.purchaseorderNotifications,
    companies: state => state.companies
  },
  mutations: {
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERNAME: (state, username) => {
      state.username = username
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_DESCRIPTION: (state, description) => {
      state.description = description
    },
    SET_CONFIRMED: (state, confirmed) => {
      state.confirmed = confirmed
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_AWAK_ROLE: (state, awakRole) => {
      state.awakRole = awakRole
    },
    SET_USER_DATA: (state, userData) => {
      state.userData = userData
    },
    SET_PROFILE_PICTURE: (state, profilePicture) => {
      state.profilePicture = profilePicture
    },
    SET_BRANCH_DATA: (state, branchData) => {
      state.branchData = branchData
    },
    SET_BRANCH_LOGO: (state, branchLogo) => {
      state.branchLogo = branchLogo
    },
    SET_FEATURES: (state, features) => {
      state.features = features
    },
    SET_CURRENT_SIPP_MODULE: (state, currentSIPPModule) => {
      state.currentSIPPModule = currentSIPPModule
    },
    SET_UNREAD_NOTIFICATIONS: (state, unreadNotifications) => {
      state.unreadNotifications = unreadNotifications
    },
    SET_REQUESTEDWHPART_NOTIFICATIONS: (state, requestedwhpartNotifications) => {
      state.requestedwhpartNotifications = requestedwhpartNotifications
    },
    SET_PURCHASEORDER_NOTIFICATIONS: (state, purchaseorderNotifications) => {
      state.purchaseorderNotifications = purchaseorderNotifications
    },
    SET_COMPANIES: (state, companies) => {
      state.companies = companies
    }
  },

  actions: {
    Login({ dispatch, commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response
          // console.log('data: ' + JSON.stringify(data))
          // setToken(data.jwt)
          commit('SET_TOKEN', data.jwt)
          // commit('SET_NAME', data.user.name)
          commit('SET_USERNAME', data.user.username)
          commit('SET_EMAIL', data.user.email)
          commit('SET_CONFIRMED', data.user.confirmed)
          getService().then(response2 => {
            const data2 = response2
            if (data2.package === undefined) {
              data2.package = 'none'
            }
            commit('SET_AWAK_ROLE', data2.package)
            commit('SET_USER_DATA', data2.userData)
            commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
            getRelations().then(async response3 => {
              const data3 = response3.data
              let branchId = null
              let features = defaultFeatures
              commit('SET_COMPANIES', data3)
              // if (store.getters.branchSelected) {
              //   try {
              //     const resp = await getBranchById(store.getters.branchSelected)
              //     branchId = store.getters.branchSelected
              //     commit('SET_BRANCH_DATA', resp)
              //     if (resp.features.length > 0) {
              //       const featureList = resp.features
              //       // console.log("branch")
              //       // console.log({
              //       //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //       //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
              //       // })
              //       for (var i in listOfFeatures) {
              //         features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              //       }
              //       // features = {
              //       //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //       //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //       //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              //       // }
              //     } else if (resp.regionId) {
              //       if (resp.regionId.features.length > 0) {
              //         const featureList = resp.regionId.features
              //         // console.log("region")
              //         // console.log({
              //         //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //         //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
              //         // })
              //         for (var i in listOfFeatures) {
              //           features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              //         }
              //         // features = {
              //         //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //         //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //         //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              //         // }
              //       } else if (resp.regionId.companyId && resp.regionId.companyId.features.length > 0) {
              //         const featureList = resp.regionId.companyId.features
              //         // console.log("company")
              //         // console.log({
              //         //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //         //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated
              //         // })
              //         for (var i in listOfFeatures) {
              //           features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              //         }
              //         // features = {
              //         //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //         //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //         //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              //         // }
              //       }
              //     }
              //   } catch (err) {
              //     commit('SET_BRANCH_SELECTED', 'null')
              //     commit('SET_BRANCH_DATA', {})
              //   }
              // } else {

              /*
              const defaultCompany = data3.length > 0 ? data3[0] : null
              const defaultRegion = defaultCompany && defaultCompany.relationId && defaultCompany.relationId.regions && defaultCompany.relationId.regions.length > 0 ? defaultCompany.relationId.regions[0] : null
              const defaultBranch = defaultRegion && defaultRegion.branches && defaultRegion.branches.length > 0 ? defaultRegion.branches[0] : null
              branchId = defaultBranch ? defaultBranch._id : null
              commit('SET_BRANCH_SELECTED', defaultBranch ? defaultBranch._id : null)
              commit('SET_BRANCH_DATA', defaultBranch ? {
                ...defaultBranch,
                company: {
                  name: defaultCompany.name
                }
              } : {})
              commit('SET_BRANCH_LOGO', defaultBranch && defaultBranch.logo ? defaultBranch.logo.path : false)
              if (defaultBranch && defaultBranch.features && defaultBranch.features.length > 0) {
                const featureList = defaultBranch.features
                // console.log("branch")
                // console.log({
                //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated
                // })
                for (var i in listOfFeatures) {
                  features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
                }
                // features = {
                //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
                //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
                // }
              } else if (defaultRegion && defaultRegion.features && defaultRegion.features.length > 0) {
                const featureList = defaultRegion.features
                // console.log("region")
                // console.log({
                //   accounting: defaultRegion.find((v) => v.featureFlag === 'accounting') !== undefined && defaultRegion.find((v) => v.featureFlag === 'accounting').activated,
                //   commercial: defaultRegion.find((v) => v.featureFlag === 'commercial') !== undefined && defaultRegion.find((v) => v.featureFlag === 'commercial').activated
                // })
                for (var i in listOfFeatures) {
                  features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
                }
                // features = {
                //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
                //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
                // }
              } else if (defaultCompany && defaultCompany.features && defaultCompany.features.length > 0) {
                const featureList = defaultCompany.features
                // console.log("company")
                // console.log({
                //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined,
                //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
                // })
                for (var i in listOfFeatures) {
                  features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
                }
                // features = {
                //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined,
                //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined,
                //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined
                // }
              }
              // }
              // console.log(features)
              commit('SET_FEATURES', features)
              if (branchId) {
                try {
                  const unread = await getUnreadNotifications(branchId)
                  commit('SET_UNREAD_NOTIFICATIONS', unread.count)
                } catch (err) {
                  console.log(err)
                }
              }
              */

              resolve({ companies: data3, awakRole: data2.package, userData: data2.userData, features: features, ...data })
            })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },
    SignInPlatform({ dispatch, commit }, data) {
      return new Promise((resolve, reject) => {
        // console.log('data: ' + JSON.stringify(data))
        // setToken(data.jwt)
        commit('SET_TOKEN', data.jwt)
        // commit('SET_NAME', data.user.name)
        commit('SET_USERNAME', data.user.username)
        commit('SET_EMAIL', data.user.email)
        commit('SET_CONFIRMED', data.user.confirmed)
        getService().then(response2 => {
          const data2 = response2
          if (data2.package === undefined) {
            data2.package = 'none'
          }
          commit('SET_AWAK_ROLE', data2.package)
          commit('SET_USER_DATA', data2.userData)
          commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
          resolve({ awakRole: data2.package, userData: data2.userData, ...data })
        })
      })
    },
    SignupIMSTijarah({ dispatch, commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        signupIMSTijarah(username, userInfo.email, userInfo.password).then(response => {
          // const data = response
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetInfo({ commit, state }, path) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response
          if (data.role && data.role.type) {
            commit('SET_ROLE', data.role.type)
          } else {
            reject('getInfo: role not found !')
          }
          // commit('SET_NAME', data.user.name)
          commit('SET_ID', data._id)
          commit('SET_USERNAME', data.username)
          commit('SET_EMAIL', data.email)
          commit('SET_DESCRIPTION', data.description)
          commit('SET_CONFIRMED', data.confirmed)
          commit('SET_AVATAR', `https://ui-avatars.com/api/?name=${data.username}`)
          commit('SET_BRANCH_SELECTED', null)
          commit('SET_BRANCH_DATA', {})
          commit('SET_BRANCH_LOGO', null)

          let relationRole = null

          let routeBranchId = null
          if (path.split('/').length > 2 && path.split('/')[1] === 'z') {
            const branchId = path.split('/')[2]
            routeBranchId = branchId
          }

          getService().then(async response2 => {
            const data2 = response2
            if (data2.package === undefined) {
              data2.package = 'none'
            }
            commit('SET_AWAK_ROLE', data2.package)
            commit('SET_USER_DATA', data2.userData)
            commit('SET_PROFILE_PICTURE', data2.userData && data2.userData.pfp ? data2.userData.pfp.path : null)
            getRelations().then(async response3 => {
              const data3 = response3.data
              let branchId = null
              let features = defaultFeatures
              commit('SET_COMPANIES', data3)
              if (routeBranchId) {
                try {
                  const resp = await getBranchById(routeBranchId)
                  branchId = routeBranchId
                  commit('SET_BRANCH_SELECTED', routeBranchId)
                  commit('SET_BRANCH_DATA', resp)
                  // console.log('SET_BRANCH_DATA', resp)
                  commit('SET_BRANCH_LOGO', resp.logo ? resp.logo.path : false)
                  relationRole = resp.relation.role
                  if (resp.features.length > 0) {
                    const featureList = resp.features
                    // console.log("branch")
                    // console.log({
                    //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                    //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
                    // })
                    for (var i in listOfFeatures) {
                      const feature = featureList.find((v) => v.featureFlag === listOfFeatures[i].key)
                      if (feature) {
                        features[listOfFeatures[i].key] = feature.activated
                        switch (listOfFeatures[i].key) {
                          case 'mindblogging': {
                            store.dispatch('SetUserHandle', feature.settings ? feature.settings.userHandle : '');
                            break
                          }
                        }
                      }
                    }
                    // features = {
                    //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                    //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
                    //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
                    // }
                  } else if (resp.regionId) {
                    if (resp.regionId.features.length > 0) {
                      const featureList = resp.regionId.features
                      // console.log("region")
                      // console.log({
                      //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                      //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
                      // })
                      for (var i in listOfFeatures) {
                        const feature = featureList.find((v) => v.featureFlag === listOfFeatures[i].key)
                        if (feature) {
                          features[listOfFeatures[i].key] = feature.activated
                          switch (listOfFeatures[i].key) {
                            case 'mindblogging': {
                              store.dispatch('SetUserHandle', feature.settings ? feature.settings.userHandle : '');
                              break
                            }
                          }
                        }
                      }
                      // features = {
                      //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                      //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
                      //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
                      // }
                    } else if (resp.regionId.companyId && resp.regionId.companyId.features.length > 0) {
                      const featureList = resp.regionId.companyId.features
                      // console.log("company")
                      // console.log({
                      //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                      //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated
                      // })
                      for (var i in listOfFeatures) {
                        const feature = featureList.find((v) => v.featureFlag === listOfFeatures[i].key)
                        if (feature) {
                          features[listOfFeatures[i].key] = feature.activated
                          switch (listOfFeatures[i].key) {
                            case 'mindblogging': {
                              store.dispatch('SetUserHandle', feature.settings ? feature.settings.userHandle : '');
                              break
                            }
                          }
                        }
                      }
                      // features = {
                      //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
                      //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
                      //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
                      // }
                      // console.log(featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated)
                      // console.log(featureList.find((v) => v.featureFlag === 'sample'))
                      // console.log(resp.regionId.companyId.features)
                    }
                  }
                } catch (err) {
                  commit('SET_BRANCH_SELECTED', null)
                  commit('SET_BRANCH_DATA', {})
                  commit('SET_BRANCH_LOGO', null)
                }
              }
              // } else {
              //   // console.log('no branch')
              //   const defaultCompany = data3.length > 0 ? data3[0] : null
              //   const defaultRegion = defaultCompany && defaultCompany.relationId && defaultCompany.relationId.regions && defaultCompany.relationId.regions.length > 0 ? defaultCompany.relationId.regions[0] : null
              //   const defaultBranch = defaultRegion && defaultRegion.branches && defaultRegion.branches.length > 0 ? defaultRegion.branches[0] : null
              //   // console.log(defaultCompany)
              //   // console.log(defaultRegion)
              //   // console.log(defaultBranch)
              //   branchId = defaultBranch ? defaultBranch._id : null
              //   commit('SET_BRANCH_SELECTED', defaultBranch ? defaultBranch._id : 'null')
              //   commit('SET_BRANCH_DATA', defaultBranch ? {
              //     ...defaultBranch,
              //     company: {
              //       name: defaultCompany.name
              //     }
              //   } : {})
              //   if (defaultBranch && defaultBranch.features && defaultBranch.features.length > 0) {
              //     const featureList = defaultBranch.features
              //     // console.log("branch")
              //     // console.log({
              //     //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //     //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated
              //     // })
              //     for (var i in listOfFeatures) {
              //       features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              //     }
              //     // features = {
              //     //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //     //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //     //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              //     // }
              //   } else if (defaultRegion && defaultRegion.features && defaultRegion.features.length > 0) {
              //     const featureList = defaultRegion.features
              //     // console.log("region")
              //     // console.log({
              //     //   accounting: defaultRegion.find((v) => v.featureFlag === 'accounting') !== undefined && defaultRegion.find((v) => v.featureFlag === 'accounting').activated,
              //     //   commercial: defaultRegion.find((v) => v.featureFlag === 'commercial') !== undefined && defaultRegion.find((v) => v.featureFlag === 'commercial').activated
              //     // })
              //     for (var i in listOfFeatures) {
              //       features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              //     }
              //     // features = {
              //     //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //     //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //     //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              //     // }
              //   } else if (defaultCompany && defaultCompany.features && defaultCompany.features.length > 0) {
              //     const featureList = defaultCompany.features
              //     // console.log("company")
              //     // console.log({
              //     //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined,
              //     //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
              //     // })
              //     for (var i in listOfFeatures) {
              //       features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              //     }
              //     // features = {
              //     //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //     //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //     //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              //     // }
              //     // console.log(featureList.find((v) => v.featureFlag === 'sample') !== undefined)
              //     // console.log(defaultCompany.features)
              //   }
              // }
              // console.log(features)
              commit('SET_FEATURES', features)
              if (branchId) {
                // the first feature that returns true
                const feature = Object.keys(features).find(key => features[key] === true)
                switch (feature) {
                  case 'imsteknobumi': {
                    try {
                      const requestedwhpart = await axios({
                        url: `${process.env.BASE_API}/imsteknobumi/requestedwhparts/notifications/${branchId}`,
                        method: 'GET',
                        headers: {
                          Authorization: `Bearer ${state.token}`
                        }
                      })
                      commit('SET_REQUESTEDWHPART_NOTIFICATIONS', requestedwhpart.data ? requestedwhpart.data : 0)
                    } catch (err) {
                      console.log(err)
                    }
                    try {
                      const purchaseorder = await axios({
                        url: `${process.env.BASE_API}/imsteknobumi/purchaseorders/notifications/${branchId}`,
                        method: 'GET',
                        headers: {
                          Authorization: `Bearer ${state.token}`
                        }
                      })
                      commit('SET_PURCHASEORDER_NOTIFICATIONS', purchaseorder.data ? purchaseorder.data : 0)
                    } catch (err) {
                      console.log(err)
                    }
                    break
                  }
                  case 'sipp': {
                    try {
                      const requestedwhpart = await axios({
                        url: `${process.env.BASE_API}/sipp/requestedwhparts/notifications/${branchId}`,
                        method: 'GET',
                        headers: {
                          Authorization: `Bearer ${state.token}`
                        }
                      })
                      commit('SET_REQUESTEDWHPART_NOTIFICATIONS', requestedwhpart.data ? requestedwhpart.data : 0)
                    } catch (err) {
                      console.log(err)
                    }
                    try {
                      const purchaseorder = await axios({
                        url: `${process.env.BASE_API}/sipp/purchaseorders/notifications/${branchId}`,
                        method: 'GET',
                        headers: {
                          Authorization: `Bearer ${state.token}`
                        }
                      })
                      commit('SET_PURCHASEORDER_NOTIFICATIONS', purchaseorder.data ? purchaseorder.data : 0)
                    } catch (err) {
                      console.log(err)
                    }
                    break
                  }
                }
                try {
                  const unread = await axios({
                    url: `${process.env.BASE_API}/serviceNotifications/notifications/unread/${branchId}`,
                    method: 'GET',
                    headers: {
                      Authorization: `Bearer ${state.token}`
                    }
                  })
                  commit('SET_UNREAD_NOTIFICATIONS', unread.count)
                } catch (err) {
                  console.log(err)
                }
              }
              resolve({ companies: data3, awakRole: data2.package, userData: data2.userData, features: features, relationRole: relationRole, ...data })
            })
          })
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetUnreadMessages({ commit, state }, branchId) {
      return new Promise(async(resolve, reject) => {
        if (branchId) {
          try {
            const unread = await getUnreadNotifications(branchId)
            commit('SET_UNREAD_NOTIFICATIONS', unread.count)
          } catch (err) {
            console.log(err)
          }
        }
        resolve()
      })
    },

    GetRequestedWHPartNotifications({ commit, state }, data) {
      return new Promise(async(resolve, reject) => {
        if (branchId) {
          try {
            const { branchId, feature } = data
            let requestedwhpart = {}
            switch (feature) {
              case 'imsteknobumi': {
                requestedwhpart = await imsteknobumiGetRequestedWHPartNotifications(branchId)
                break
              }
              case 'sipp': {
                requestedwhpart = await sippGetRequestedWHPartNotifications(branchId)
                break
              }
            }
            commit('SET_REQUESTEDWHPART_NOTIFICATIONS', requestedwhpart.count)
          } catch (err) {
            console.log(err)
          }
        }
        resolve()
      })
    },

    GetPurchaseOrderNotifications({ commit, state }, data) {
      return new Promise(async(resolve, reject) => {
        if (branchId) {
          try {
            const { branchId, feature } = data
            let purchaseorder = {}
            switch (feature) {
              case 'imsteknobumi': {
                purchaseorder = await imsteknobumiGetPurchaseOrderNotifications(branchId)
                break
              }
              case 'sipp': {
                purchaseorder = await sippGetPurchaseOrderNotifications(branchId)
                break
              }
            }
            commit('SET_PURCHASEORDER_NOTIFICATIONS', purchaseorder.count)
          } catch (err) {
            console.log(err)
          }
        }
        resolve()
      })
    },

    GetBranch({ commit, state }, branchId) {
      return new Promise(async(resolve, reject) => {
        try {
          const resp = await getBranchById(branchId)
          commit('SET_BRANCH_SELECTED', branchId)
          commit('SET_BRANCH_DATA', resp)
          commit('SET_BRANCH_LOGO', resp.logo ? resp.logo.path : false)
          let features = defaultFeatures
          if (resp.features.length > 0) {
            const featureList = resp.features
            // console.log("branch")
            // console.log({
            //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
            //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
            // })
            for (var i in listOfFeatures) {
              features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
            }
            // features = {
            //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
            //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
            //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
            // }
          } else if (resp.regionId) {
            if (resp.regionId.features.length > 0) {
              const featureList = resp.regionId.features
              // console.log("region")
              // console.log({
              //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined
              // })
              for (var i in listOfFeatures) {
                features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              }
              // features = {
              //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              // }
            } else if (resp.regionId.companyId && resp.regionId.companyId.features.length > 0) {
              const featureList = resp.regionId.companyId.features
              // console.log("company")
              // console.log({
              //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated
              // })
              for (var i in listOfFeatures) {
                features[listOfFeatures[i].key] = featureList.find((v) => v.featureFlag === listOfFeatures[i].key) !== undefined && featureList.find((v) => v.featureFlag === listOfFeatures[i].key).activated
              }
              // features = {
              //   accounting: featureList.find((v) => v.featureFlag === 'accounting') !== undefined && featureList.find((v) => v.featureFlag === 'accounting').activated,
              //   commercial: featureList.find((v) => v.featureFlag === 'commercial') !== undefined && featureList.find((v) => v.featureFlag === 'commercial').activated,
              //   sample: featureList.find((v) => v.featureFlag === 'sample') !== undefined && featureList.find((v) => v.featureFlag === 'sample').activated
              // }
            }
          }
          commit('SET_FEATURES', features)
          if (branchId) {
            try {
              const unread = await axios({
                url: `${process.env.BASE_API}/serviceNotifications/notifications/unread/${branchId}`,
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${state.token}`
                }
              })
              commit('SET_UNREAD_NOTIFICATIONS', unread.count)
            } catch (err) {
              console.log(err)
            }
            try {
              const requestedwhpart = await axios({
                url: `${process.env.BASE_API}/imsteknobumi/requestedwhparts/notifications/${branchId}`,
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${state.token}`
                }
              })
              commit('SET_REQUESTEDWHPART_NOTIFICATIONS', requestedwhpart.count)
            } catch (err) {
              console.log(err)
            }
            try {
              const purchaseorder = await axios({
                url: `${process.env.BASE_API}/imsteknobumi/purchaseorders/notifications/${branchId}`,
                method: 'GET',
                headers: {
                  Authorization: `Bearer ${state.token}`
                }
              })
              commit('SET_PURCHASEORDER_NOTIFICATIONS', purchaseorder.count)
            } catch (err) {
              console.log(err)
            }
          }
          resolve({ ...resp })
        } catch (err) {
          reject(err)
        }
      })
    },
    // 登出
    LogOut({ dispatch, commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLE', '')
        commit('SET_NAME', '')
        commit('SET_USERNAME', '')
        commit('SET_EMAIL', '')
        commit('SET_AVATAR', '')
        commit('SET_DESCRIPTION', '')
        commit('SET_CONFIRMED', '')
        commit('SET_USER_DATA', {})
        commit('SET_BRANCH_DATA', {})
        commit('SET_BRANCH_LOGO', null)
        commit('SET_FEATURES', defaultFeatures)
        commit('SET_UNREAD_NOTIFICATIONS', 0)
        commit('SET_COMPANIES', [])
        resolve()
      })
    },
    SetCurrentSIPPModule({ commit }, module) {
      commit('SET_CURRENT_SIPP_MODULE', module)
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        // removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js